import {HttpResponse} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {SettingsService} from "../settings/settings.service";
import {LoggingService} from "./log.service";
import {RestfulService} from "./restful.service";
import {ProjectInfo} from "../interfaces/project.interface";
import * as ENDPOINT from "../../shared/constant/endPoint.js";
import {getEndPointWithParams} from "../../../assets/js/util.js";
import {UtilsService} from './utils.service';
import {Specifications, SpecificationsActions, SpecificationsBuyer, SpecificationsItem} from "../interfaces/specifications.interface";
import {Document} from "../interfaces/workflow.interface";


@Injectable({
  providedIn: "root",
})
export class SpecificationsService {
  typeAction: SpecificationsActions;

  projectSaved: ProjectInfo = null;

  constructor(
    private logger: LoggingService,
    private settings: SettingsService,
    private restful: RestfulService,
    private utils: UtilsService
  ) {}

  setTypeAction(typeAction: SpecificationsActions): void {
    this.typeAction = typeAction;
  }

  getTypeAction(): SpecificationsActions {
    return this.typeAction;
  }

  getSpecifications(idProject: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_specifications, idProject);
    return this.get(endPoint);
  }

  updateSpecifications(idProject: number, contract: Specifications): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_specifications, idProject);
    return this.post(endPoint, contract);
  }

  getBuyerList(idProject: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_buyer, idProject);
    return this.get(endPoint);
  }


  getBuyer(id: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_buyer_byId, id);
    return this.get(endPoint);
  }

  createBuyer(idProject: number, contract: SpecificationsBuyer): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_buyer, idProject);
    return this.post(endPoint, contract);
  }

  updateBuyer(idBuyer: number, contract: SpecificationsBuyer): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_buyer_byId, idBuyer);
    return this.put(endPoint, contract);
  }

  deleteBuyer(idBuyer: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_buyer_byId, idBuyer);
    return this.delete(endPoint);
  }

  toggleBuyer(idBuyer: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_buyer_toggle, idBuyer);
    return this.put(endPoint, {});
  }

  getItemList(idProject: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_item, idProject);
    return this.get(endPoint);
  }


  createItem(idProject: number, item: SpecificationsItem): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_item, idProject);
    return this.post(endPoint, item);
  }

  updateItem(idItem: number, item: SpecificationsItem): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_item_byId, idItem);
    return this.put(endPoint, item);
  }

  deleteItem(idItem: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_item_byId, idItem);
    return this.delete(endPoint);
  }

  toggleItem(idItem: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_item_toggle, idItem);
    return this.put(endPoint, {});
  }

  getStandardDocuments(reqBody: any, idProject: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_specifications_documents, idProject);
    return this.post(endPoint, reqBody);
  }

  uploadStandardDocuments(idContract: number, standardDocuments: Document[]): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_specifications_documents_upload, idContract);
    return this.post(endPoint, standardDocuments);
  }

  getExtraDocuments(reqBody: any, idProject: number): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_specifications_documents_extra, idProject);
    return this.post(endPoint, reqBody);
  }

  uploadExtraDocuments(idContract: number, extraDocuments: Document[]): Observable<any> {
    const endPoint = getEndPointWithParams(ENDPOINT.project_specifications_documents_extra_upload, idContract);
    return this.post(endPoint, extraDocuments);
  }



  /* RESTFUL METHOD */
  post(endPoint: string, reqBody: any): Observable<any> {
    return Observable.create((observer) => {
      this.restful.post(endPoint, reqBody).subscribe((response: any) => {
        this.responseHandler(response, observer);
      });
    });
  }

  put(endPoint: string, reqBody: any): Observable<any> {
    return Observable.create((observer) => {
      this.restful.put(endPoint, reqBody).subscribe((response: any) => {
        this.responseHandler(response, observer);
      });
    });
  }

  delete(endPoint: string): Observable<any> {
    return Observable.create((observer) => {
      this.restful.delete(endPoint).subscribe((response: any) => {
        this.responseHandler(response, observer);
      });
    });
  }

  get(endPoint: string): Observable<any> {
    return Observable.create((observer) => {
      this.restful.get(endPoint).subscribe((response: any) => {
        this.responseHandler(response, observer);
      });
    });
  }

  responseHandler(response: HttpResponse<any>, observer: any): void {
    const outcome = response["outcome"];
    if (outcome.success === true) {
      this.logger.log("Service:", "SUCCESS", 200);
      observer.next(response);
    } else {
      this.logger.log("Service:", "FAILURE", 200);
      outcome.message = this.utils.manageErrorMsg(outcome);
      observer.error(outcome);
    }
  }

}
